module.exports = __webpack_public_path__ + "static/icons/icon-no-banners-08188ff2cd95fde3db180d8f85ca3f7a.svg";